module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAMAAABf788oAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTP///////////////////////////////////////////////////////////////8/RimEAAAAQdFJOUwBVGs7uPav5Bi7ZD4HDdeQEq6p2AAAAWElEQVR42oXRSRKAMAhEUZOQAY36739at7EXgeWromjgiGukZ/ygQckrdOD1BQCwKkBPAjAVaEOA+xLgzAKYC9CrACUCbTHXsRpsH33u17eqJ9Qj794Q1wdByg0JxfqNtAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/top_icon.png
// module id = Kprn
// module chunks = 1